const MOBILE_VIEWPORT = "(max-width: 639px)"

export const MobileKanbanInitialColumn = {
  mounted() {
    this.firstFrame = requestAnimationFrame(() => {
      this.secondFrame = requestAnimationFrame(() => {
        this.showInitialMobileColumn()
      })
    })
  },

  destroyed() {
    cancelAnimationFrame(this.firstFrame)
    cancelAnimationFrame(this.secondFrame)
  },

  showInitialMobileColumn() {
    if (!window.matchMedia(MOBILE_VIEWPORT).matches) return

    const initialColumn = this.el.dataset.initialMobileColumn
    const board = this.el.querySelector("#kanban_board")
    const column = board
      ?.querySelector(`[data-queue="${initialColumn}"]`)
      ?.closest("[data-kanban-column-frame]")

    if (!initialColumn || !board || !column) return

    const boardRect = board.getBoundingClientRect()
    const columnRect = column.getBoundingClientRect()

    board.scrollLeft +=
      columnRect.left -
      boardRect.left -
      (board.clientWidth - columnRect.width) / 2
  },
}
